import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)

/** Joins name segments with a single space, omitting null/undefined/empty strings. */
export function joinNameParts(...parts: (string | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ')
}

export const getShortText = (text: string, n: number) => {
  if (text.length <= 2 * n) return text
  return `${text.slice(0, n)}...${text.slice(-n)}`
}

/** Truncate long URLs for display */
export function truncateUrl(url: string, maxLength = 50): string {
  if (url.length <= maxLength) return url
  return url.substring(0, maxLength) + '...'
}

/**
 * Formats a date value to YYYY-MM-DD.
 * Accepts:
 *   - Plain date string "YYYY-MM-DD"
 *   - ISO datetime string "YYYY-MM-DDTHH:mm:ss.sssZ"
 *   - Date object
 *
 * @param tz - Optional IANA timezone (e.g. "America/Los_Angeles").
 *             When provided, the value is converted to that timezone before
 *             extracting the date. When omitted, the date portion is used as-is.
 *
 * Returns '' for null/undefined/invalid values.
 */
export function formatDateForCsv(
  value: string | Date | null | undefined,
  tz?: string
): string {
  if (value == null) return ''

  if (tz) {
    const d = dayjs(value).tz(tz)
    if (!d.isValid()) return ''
    return d.format('YYYY-MM-DD')
  }

  // No timezone: plain date-only string returned as-is
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value
  }

  // ISO datetime or Date object — strip the time portion without TZ shifting
  const d = dayjs(value)
  if (!d.isValid()) return ''
  return d.format('YYYY-MM-DD')
}
